const roles = {
  admin: 'admin',
  manager: 'manager',
  storeman: 'storeman',
  cashier: 'cashier',
};

export default roles;
